import {useCallback, useState} from 'react';

/**
 * Run a possibly-async action (e.g. a download that fetches first) and track
 * whether it's still running, so its button can be disabled meanwhile.
 * Failures go to `onError`; without one they're rethrown.
 */
export const usePendingAction = (
  action: (() => void | Promise<void>) | undefined,
  onError?: (error: unknown) => void
): {run: () => Promise<void>; isPending: boolean} => {
  const [isPending, setIsPending] = useState(false);
  const run = useCallback(async () => {
    if (!action) {
      return;
    }
    setIsPending(true);
    try {
      await action();
    } catch (error) {
      if (!onError) {
        throw error;
      }
      onError(error);
    } finally {
      setIsPending(false);
    }
  }, [action, onError]);
  return {run, isPending};
};
